import { useFormikContext } from 'formik'
import { ReactNode } from 'react'
import { Button } from '../Button/Button'
import { ButtonSize } from 'components/Button/Types'

interface Props {
  children: ReactNode
  size?: ButtonSize
}

export const FormikSubmitButton = ({ children, size = 'lg' }: Props) => {
  const { isSubmitting, submitForm } = useFormikContext()

  return (
    <Button size={size} type="submit" isDisabled={isSubmitting} onPress={submitForm}>
      {children}
    </Button>
  )
}
